<div class="games-running-modal-container d-flex flex-column pb-4" style="height: 400px" [ngClass]="{'cxone-container': isCxone}">
    <div class="modal-header my-1" [ngClass]="{'modal-challenges-header': isCxone}">
        <h6 class="modal-title lato-bold" cvLocalizedText langSection="Challenges" [langKey]="challengeDetailsTitle" [hidden]="isCxone">Challenged users details</h6>
        <h6 class="modal-title lato-bold challenge-details" cvLocalizedText langSection="Challenges" langKey="Challenge_Details" [hidden]="!isCxone">Challenge Details</h6>
        <div class="export-element">
            <cv-generic-export [items]="exportOptions" [fileName]="getLocalizedMessage('User_Details', 'Challenged users details')" [hidden]="isCxone"></cv-generic-export>
            <sol-button [variant]="'basic'"
                        [size]="'large'"
                        [matMenuTriggerFor]="menu.menu"
                        [hidden]="!isCxone"
                        class="ml-auto export-button">
                <span cvLocalizedText langSection="Module_Menu" langKey="Export" class="line-height-buttom">Export</span>
            </sol-button>

            <sol-floating-menu #menu
                menuClass="export-menu-challenge"
                [menuItems]="defaultMenuOptions"
                [spriteIconPath]="'../App_Themes/CXone/icons/export-menu-icons.svg'"
                position="'bottom'">
            </sol-floating-menu>
            <button type="button" class="close" aria-label="Close" (click)="close()" [ngClass]="{'modal-close': isCxone}"><span aria-hidden="true">&times;</span></button>
        </div>
    </div>

    <div class="modal-body flex-fill pt-0">
        <div class="performanceContent w-100" [ngClass]="{'mt-4': !isCxone}">
            <ag-grid-angular #challengeUsersModalGrid *ngIf="usersDetails" class="performanceTable ag-theme-balham flex-fill" style="height: 100%; flex-grow:1;" [gridOptions]="usersDetails"></ag-grid-angular>
        </div>
    </div>
    <sol-button [variant]="'basic'"
                [size]="'large'"
                (click)="close()" [hidden]="!isCxone"
                class="ml-auto button-close">
        <span cvLocalizedText langSection="Common" langKey="Close">Close</span>
    </sol-button>
</div>
